module.exports = __webpack_public_path__ + "static/Icon3-13f96ee26399d33f6caabcae8d573b02.png";